import React from 'react';
import { Filters } from '../Filters';

export function Sidebar({ filters, onFilterChange }) {
  return (
    <aside className="w-64 flex-shrink-0 hidden md:block">
      <div className="sticky top-4">
        <Filters filters={filters} onFilterChange={onFilterChange} />
      </div>
    </aside>
  );
}